import { render, staticRenderFns } from "./TaskDetailTaskDialog.vue?vue&type=template&id=55b69dab&scoped=true&"
import script from "./TaskDetailTaskDialog.vue?vue&type=script&lang=js&"
export * from "./TaskDetailTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailTaskDialog.vue?vue&type=style&index=0&id=55b69dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b69dab",
  null
  
)

export default component.exports